import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)({
  border: 0,
  padding: '0 0 !important',
  margin: '2px!important',
  minWidth: '20px!important',
  borderRadius: '20px!important',
  textTransform: 'capitalize',
});

interface ButtonDayProps {
  text: string;
  selectDays: (e: React.MouseEvent<HTMLButtonElement>) => void;
  selected?: boolean;
  dayId: string;
  alreadySelected?: boolean;
}

export default function ButtonDay({ text, selectDays, selected, dayId, alreadySelected }: ButtonDayProps) {
  const [flag, setFlag] = React.useState(selected);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setFlag(!flag);
    selectDays(e);
  };

  return (
    <StyledButton
      onClick={handleClick}
      variant="contained"
      style={{ backgroundColor: flag ? '#2C367E' : 'white', color: flag ? 'white' : '#2C367E' }}
      data-id={dayId}
      disabled={alreadySelected}
    >
      {text}
    </StyledButton>
  );
}
